import { render, staticRenderFns } from "./ProductDetailAccordion.vue?vue&type=template&id=3324ac0c&scoped=true&"
import script from "./ProductDetailAccordion.vue?vue&type=script&lang=js&"
export * from "./ProductDetailAccordion.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailAccordion.vue?vue&type=style&index=0&id=3324ac0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3324ac0c",
  null
  
)

export default component.exports